import { Modal } from 'reactstrap';
import styled from 'styled-components';
import { IconTakeatFilled, TakeatLogo } from 'takeat-design-system-ui-kit';

export const Container = styled.div`
  position: relative;
  width: 100%;
  display: flex;
  height: 48px;
  padding-inline: 12px;
  justify-content: space-between;
  align-items: center;
  align-self: stretch;
  background: #fff;
`;

export const ErrorDeliveryNotConfigured = styled.div`
  width: 100%;
  display: flex;
  height: 48px;
  padding: 10px 20px;
  background: #fff6e5;
  align-items: center;
  justify-content: center;
  span {
    color: #3d3d3d;
    font-weight: 600;
    margin-left: 16px;
    margin-right: 16px;
  }
`;

export const StatuaSquare = styled.div`
  width: 214px;
  height: 94px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  background-color: ${(props) => (props?.active ? '#ECFFFD' : '#FFF0F2')};

  span {
    font-weight: bold;
    color: #6c6c6c;
  }
`;

export const Logo = styled.img`
  width: 140px;
  position: absolute;
  left: 50%;
  transform: translateX(-50%);

  @media (max-width: 1300px) {
    position: relative;
    left: 0;
    transform: translateX(0%);
  }

  @media (max-width: 1080px) {
    display: none;
  }
`;

export const TakeatLogoStyled = styled(TakeatLogo)`
  height: 36px;
  fill: ${({ theme }) => theme.colors.primary.default};

  @media (max-width: 1080px) {
    display: none;
  }
`;

export const TakeatIconStyled = styled(IconTakeatFilled)`
  flex-shrink: 0;
  font-size: 36px;
  fill: ${({ theme }) => theme.colors.primary.default};

  @media (min-width: 1081px) {
    display: none;
  }
`;

export const ButtonsDiv = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
`;

export const HeaderButton = styled.button`
  position: relative;
  display: flex;
  width: fit-content;
  min-width: 50px;
  height: 40px;
  padding: 4px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 2px;
  border-radius: 5px;
  border: 1px solid transparent;
  background: ${({ theme }) => theme.colors.neutral.lightest};
  color: ${({ theme }) => theme.colors.primary.default};
  transition: all 0.2s;

  &:hover {
    border: 1px solid
      ${({ theme, color }) =>
        color ? theme.colors[color].default : theme.colors.primary.default};
  }

  span {
    color: ${({ theme, color }) =>
      color ? theme.colors[color].default : theme.colors.primary.default};
    text-align: center;
    font-family: Poppins;
    font-size: 8px;
    font-style: normal;
    font-weight: 600;
    line-height: 12px;
  }

  svg {
    flex-shrink: 0;
    font-size: 18px;
    fill: ${({ theme, color }) =>
      color ? theme.colors[color].default : theme.colors.primary.default};
  }
`;

export const RightButtonsDiv = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 4px;
`;

export const UserName = styled.span`
  margin-left: 4px;
  color: ${({ theme }) => theme.colors.neutral.dark};
  font-family: Poppins;
  font-weight: 700;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0.1px;
  text-align: left;
  transition: width 0.3s;

  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  width: ${({ isSidebarOpen }) => (isSidebarOpen ? '0px' : '200px')};
`;

export const RestaurantInfo = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding: 10px 0;

  margin-top: -5px;
  border-bottom: 1px solid ${(props) => props.theme.colors.lightGray};

  span {
    margin-left: 10px;
    font-size: 16px;
  }
`;

export const WppButton = styled.button`
  display: flex;
  gap: 10px;
  align-items: center;
  border: 1px solid #33333320;
  border-radius: 4px;
  padding: 5px 10px;
  background-color: transparent;
  margin: 5px 10px 0 0;

  span {
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    color: ${(props) => (props.connected ? 'green' : '#ff403d')};
    text-align: center;
  }

  svg {
    color: ${(props) => (props.connected ? 'green' : '#ff403d')};
  }
`;

export const WppReconnect = styled.div`
  z-index: 1200;
  display: ${(props) => (props.show ? 'flex' : 'none')};
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 15px;
  position: absolute;
  top: 40px;
  right: -320px;
  width: 390px;
  background-color: #ffffff;
  border-radius: 12px;
  padding: 20px 12px;
  box-shadow: 1px 1px 5px 1px rgba(0, 0, 0, 0.2);
`;

export const WppModal = styled(Modal)`
  .modal-content {
    width: 600px;
    border-radius: 10px;
  }

  img {
    border-radius: 10px;
  }

  h1 {
    margin: 20px 0;

    font-style: normal;
    font-weight: 700;
    font-size: 20px;
    color: #000000;
    text-align: center;
  }

  p {
    width: 505px;
    margin: 0 auto;
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
    text-align: center;
    color: #000000;
  }
`;

export const ReconnectButton = styled.button`
  width: 233px;
  height: 48px;
  line-height: 48px;
  background: #ff2c3a;
  border-radius: 5px;
  border: none;
  margin: 80px auto 20px;

  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  text-align: center;
  color: #ffffff;

  &:hover {
    color: #ffffff;
    text-decoration: none;
  }

  &:focus {
    color: #ffffff;
    text-decoration: none;
  }
`;

export const WppDetailsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  width: 100%;
  padding: 16px;
  background: #f8f8f8;
  border-radius: 8px;
  margin-bottom: 12px;
`;

export const WppDetailRow = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;

  &.phone-number {
    font-size: 16px;
    font-weight: 500;
    color: #2d2d2d;
  }

  &.instance-name {
    font-size: 14px;
    color: #666;
  }

  &.created-date {
    font-size: 12px;
    color: #999;
  }
`;

export const FlagIcon = styled.span`
  font-size: 20px;
  line-height: 1;
`;

export const PendingNotification = styled.div`
  position: absolute;
  top: 9px;
  right: 9px;
  width: 9px;
  height: 9px;
  border-radius: 9px;
  background-color: #ffa814;
`;

export const Badge = styled.div`
  z-index: 99;
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  right: -4px;
  top: -4px;
  width: 19px;
  height: 19px;
  font-size: 12px;
  border-radius: 9px;
  background-color: ${({ theme }) => theme.colors.yellow.default};
  font-weight: 600;
  color: white;
  box-shadow: ${({ theme }) => theme.shadows.light};
`;

export const StatusButtonsArea = styled.div`
  display: flex;
  justify-content: space-around;
  align-items: center;
  gap: 4px;
`;

export const StatusButton = styled.button`
  width: fit-content;
  height: 40px;
  background-color: ${({ opened }) => (opened ? '#E0F7F4' : '#FFF0F2')};
  display: flex;
  align-items: center;
  border: none;
  padding: 8px 12px;
  gap: 8px;
  border-radius: 8px;

  span {
    color: ${({ theme }) => theme.colors.neutral.dark};
    font-size: 14px;
    font-weight: 600;
  }

  svg {
    flex-shrink: 0;
    font-size: 20px;
    fill: ${({ theme }) => theme.colors.neutral.dark};
  }
`;

export const StatusCircle = styled.div`
  width: 20px;
  height: 20px;
  color: #fff;
  border-radius: 50%;
  background-color: ${({ theme, opened }) =>
    theme.colors[opened ? 'green' : 'red'].default};
  font-size: 8px;
  font-weight: 700;
  display: flex;
  justify-content: center;
  align-items: center;
`;
